import React from "react";
import { Form, Row, Col } from "react-bootstrap";

// Section-level metadata editor -- shown in the Properties panel when a
// section is selected but no individual field is (see
// FormFieldPropertiesPanel.jsx). Field list + add/reorder/remove now live
// on the canvas (FormCanvas.jsx) as part of the Part B drag-and-drop
// rebuild; this component keeps exactly the same section fields it always
// had (title/description/repeatable/scoring), just without the field list.
export default function FormSectionEditor({ section, onChangeSection, readOnly, sectionsWeightageTotal }) {
  if (!section) {
    return <div className="text-muted p-3">Select or add a section to begin.</div>;
  }

  const updateSection = (patch) => onChangeSection({ ...section, ...patch });
  const weightageTotalKnown = typeof sectionsWeightageTotal === "number";
  const weightageTotalValid = weightageTotalKnown && Math.round(sectionsWeightageTotal) === 100;

  return (
    <div className="form-section-editor">
      <div className="form-properties-panel-heading">Section Properties</div>

      <div className="form-props-group">
        <div className="form-props-group-label">Basic</div>
        <Row className="g-2">
          <Col md={12}>
            <Form.Label className="small">Section Title</Form.Label>
            <Form.Control disabled={readOnly} value={section.title || ""} onChange={(e) => updateSection({ title: e.target.value })} />
          </Col>
          <Col md={12}>
            <Form.Label className="small">Description</Form.Label>
            <Form.Control disabled={readOnly} value={section.description || ""} onChange={(e) => updateSection({ description: e.target.value })} />
          </Col>
        </Row>
      </div>

      <div className="form-props-group">
        <div className="form-props-group-label">Behaviour</div>
        <Row className="g-2">
          <Col md={12}>
            <Form.Check
              type="checkbox"
              label="Repeatable section (e.g. UAT test-case rows)"
              disabled={readOnly}
              checked={!!section.is_repeatable}
              onChange={(e) => updateSection({ is_repeatable: e.target.checked })}
            />
          </Col>
          {section.is_repeatable && (
            <>
              <Col md={6}>
                <Form.Label className="small">Minimum Repetitions</Form.Label>
                <Form.Control type="number" disabled={readOnly} value={section.minimum_repetitions ?? ""} onChange={(e) => updateSection({ minimum_repetitions: e.target.value })} />
              </Col>
              <Col md={6}>
                <Form.Label className="small">Maximum Repetitions</Form.Label>
                <Form.Control type="number" disabled={readOnly} value={section.maximum_repetitions ?? ""} onChange={(e) => updateSection({ maximum_repetitions: e.target.value })} />
              </Col>
            </>
          )}
        </Row>
      </div>

      <div className="form-props-group">
        <div className="form-props-group-label">Scoring</div>
        <Row className="g-2">
          <Col md={12}>
            <Form.Check
              type="checkbox"
              label="Score this section"
              disabled={readOnly}
              checked={!!section.score_enabled}
              onChange={(e) => updateSection({ score_enabled: e.target.checked })}
            />
          </Col>
          {section.score_enabled && (
            <>
              <Col md={6}>
                <Form.Label className="small">Weightage % (Weighted Sections)</Form.Label>
                <Form.Control type="number" min={0} max={100} disabled={readOnly} value={section.weightage ?? ""} onChange={(e) => updateSection({ weightage: e.target.value })} />
              </Col>
              <Col md={6}>
                <Form.Label className="small">Minimum Passing Score</Form.Label>
                <Form.Control type="number" disabled={readOnly} value={section.minimum_passing_score ?? ""} onChange={(e) => updateSection({ minimum_passing_score: e.target.value })} />
              </Col>
              {weightageTotalKnown && (
                <Col md={12}>
                  <div className={`form-weightage-hint ${weightageTotalValid ? "is-valid" : "is-invalid"}`}>
                    Scored sections total: {sectionsWeightageTotal}% — total section weightage must equal 100%.
                  </div>
                </Col>
              )}
            </>
          )}
        </Row>
      </div>
    </div>
  );
}
